import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const OnzeAuto = ({featuredProjectsList}) => {
  const project = getProject('onzeauto');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <Image
          component={{
            image:
              '//images.yourmajesty.co/20180226123600/180115-oa-case_cover.png'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="turning-an-old-dream-into-lovable-product">
            Turning an old dream into lovable product
          </h2>
          <p>
            Two ambitious entrepreneurs approached our Amsterdam team with a
            10-year-old vision to offer sustainable mobility for everyone.{' '}
          </p>
          <p>
            They had a concept for solving the problem of limited mobility
            access in rural areas and needed a service design partner to bring
            their vision to market.
          </p>
        </AnimateIn>

        <Image
          component={{
            image:
              '//images.yourmajesty.co/20180226122731/180115-oa-case_003.png'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            For 10 weeks we strategized, designed, prototyped, validated and
            iterated our way towards co-creating a brand new company: OnzeAuto.
          </p>
          <p>
            OnzeAuto offers an online platform that analyzes a user‘s mobility
            needs and then presents cost-effective options for them to lease
            electric cars with others.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image:
              '//images.yourmajesty.co/20180226123541/180115-oa-case_005.png',
            caption: 'Onze Auto means ”Our Car” in dutch.'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="focusing-on-a-trustworthy-onboarding">
            Focusing on a trustworthy onboarding
          </h2>
          <p>
            We put a lot of focus on designing a seamless, easy to understand,
            and enjoyable onboarding. Its primary goal is to hold the user‘s
            hand throughout the daunting process of leasing an electric car with
            other people—a task that presents a new mental model for most users.
          </p>
        </AnimateIn>

        <Image
          className="component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20180226123538/180115-oa-case_004.png'
          }}
        />

        <Image
          className="component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20180227090308/180115-oa-case_008.png'
          }}
        />

        <Image
          className="component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20180226123547/180115-oa-case_007.png'
          }}
        />

        <Image
          component={{
            image:
              '//images.yourmajesty.co/20180226123544/180115-oa-case_006.png'
          }}
        />

        <Quote
          className="g-row quote--marks"
          component={{
            quote:
              'The team proved to be an excellent blend of deep and diverse expertise, combined with a strong sense of collegiality. \
              They ask for the Why, which brings a lot of focus.',
            quotee: 'Marcel Kloprogge, Managing Partner'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="putting-the-wheels-in-motion">
            Putting the wheels in motion
          </h2>
          <p>
            In February 2018 we rolled out the first version of OnzeAuto and we
            can't wait to receive real customer feedback and use it to iterate
            towards market fit.{' '}
          </p>
          <p>
            The journey has just begun and so far we're proud to contribute
            towards the sustainable mobility revolution.
          </p>
        </AnimateIn>

        <LinkButton
          className="g-row"
          component={{
            url: 'http://www.onzeauto.com/',
            title: 'Visit OnzeAuto.'
          }}
        />

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Brand Strategy',
                  'Collaborative Working Sessions',
                  'Communications Strategy',
                  'Content Strategy',
                  'Creative Strategy',
                  'Interviews & User Testing',
                  'Launch Strategy',
                  'Product Strategy',
                  'Prototyping & Validation',
                  'Research',
                  'Roadmapping',
                  'Technical Strategy',
                  'UX Strategy',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: [
                  '3D Animation',
                  'Art Direction',
                  'Brand Design',
                  'Creative Direction',
                  'Illustration',
                  'Motion Design',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Back-end Development',
                  'Content Management System',
                  'DevOps',
                  'Front-end Development',
                  'Systems Architecture'
                ]
              },

              {
                title: 'Delivery',
                items: [
                  'A/B Testing',
                  'Analytics & Insights',
                  'Launch',
                  'Monitoring',
                  'Quality Assurance'
                ]
              },

              {
                title: 'Content',
                items: ['Animation']
              }
            ]
          }}
        />

        <LinkButton
          className="g-row"
          component={{
            url: 'https://onzeauto.com/',
            title: 'Visit website'
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default OnzeAuto;
